import { useSubscription } from "@apollo/client/react";




















































































export const useDataClientSubscription = useSubscription;
